import { Box, BoxProps } from '@mui/material';

export const VectorSettings = (props: BoxProps): JSX.Element => {
  return (
    <Box {...props}>
      <svg
        width="61"
        height="55"
        viewBox="0 0 61 55"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.4824 0.297054C11.5416 -0.281829 10.3097 0.0115047 9.73087 0.952232L0.297428 16.2823C-0.281451 17.223 0.0118819 18.4549 0.952609 19.0338C1.89334 19.6127 3.12522 19.3193 3.70411 18.3786L12.0894 4.75189L25.7161 13.1372C26.6568 13.716 27.8887 13.4227 28.4676 12.482C29.0465 11.5413 28.7531 10.3094 27.8124 9.73049L12.4824 0.297054ZM58.1272 54.9772C59.2187 55.1466 60.2409 54.3991 60.4103 53.3076C60.5797 52.2161 59.8322 51.1939 58.7407 51.0245L58.434 53.0009L58.1272 54.9772ZM11.4342 2.00039L9.4886 2.46367C14.5443 23.6957 27.8791 50.2825 58.1272 54.9772L58.434 53.0009L58.7407 51.0245C30.9901 46.7175 18.3248 22.3043 13.3798 1.53711L11.4342 2.00039Z"
          fill="#FBB92D"
        />
      </svg>
    </Box>
  );
};
